import React, { Component } from 'react'
import { Button, Input, Icon } from 'semantic-ui-react'
import { setCookie, getCookie } from '../../utils/cookies'

require('./login.scss')

export default class Login extends Component {
  constructor() {
    super()

    let nickname = getCookie('NICKNAME')
    if (!nickname) {
      nickname = this.randomNick()
    }

    this.state = {
      nickname: nickname,
      loading: false,
      nicknameValidated: true,
    }

    this.handleNicknameChange = this.handleNicknameChange.bind(this)
    this.handleLoginClick = this.handleLoginClick.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  render() {
    const loginButtonOpacity = this.state.nicknameValidated ? 1.0 : 0

    return (
      <div className="login-container">
        <video playsInline loop muted autoPlay className="backgroundVideo">
          <source src="/video/backgroundVideo.mp4" type="video/mp4" />
        </video>

        <div className="videoShield">
          <div className="videoShield-logo" />
        </div>

        <div className="login-container-box">
          <a href="https://www.the-cabin.com" target="_new">
            <center>
              <img className="header-logo" src="/blackCabinLogo.svg" />
            </center>
          </a>

          {this.errorView()}

          <h1 className="login-container-row login-header">What nickname would you like to go by?</h1>
          <div className="login-container-row">
            <Input focus iconPosition="left" placeholder="Nickname" loading={this.state.loading} size="large">
              <Icon name="user" />
              <input
                minLength="3"
                maxLength="9"
                autoComplete="off"
                autoFocus="on"
                value={this.state.nickname}
                onKeyPress={e => this.handleKeyPress(e)}
                onChange={this.handleNicknameChange}
              />
            </Input>
          </div>

          <div className="login-container-row">
            <Button basic color="grey" onClick={this.handleLoginClick} style={{ opacity: loginButtonOpacity }}>
              Join #TheCabin
            </Button>
          </div>

          <div className="login-container-row">
            <center>Or try one of our apps.</center>
            <div className="apps-container">
              <a href="https://itunes.apple.com/us/app/thecabin/id395148231?mt=12">
                <img src="/applestore.svg" alt="Apple app store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.gabekangas.thecabin">
                <img src="/androidstore.png" alt="Google play store" />
              </a>
            </div>
          </div>

          <div className="login-container-row helprow">
            <a href="https://www.the-cabin.com/help">Need help?</a>
          </div>
        </div>
      </div>
    )
  }

  errorView() {
    if (this.props.error) {
      return (
        <div className="login-container-row error">
          <span className="error-prefix">Error</span>: {this.props.error}. Visit{' '}
          <a href="https://www.the-cabin.com/help" target="_new">
            help
          </a>{' '}
          for more information or try again.
        </div>
      )
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.handleLoginClick()
    }
  }

  handleNicknameChange(event) {
    const nicknameValidated = this.state.nickname !== null && event.target.value.length > 2
    this.setState({
      nickname: this.normalizeNickname(event.target.value),
      nicknameValidated: nicknameValidated,
    })
  }

  handleLoginClick(event) {
    if (!this.state.nickname || !this.state.nickname.length > 2) {
      return
    }

    setCookie('NICKNAME', this.state.nickname)
    if (this.props.handleLogin) {
      this.props.handleLogin(this.state.nickname)
    }
  }

  randomNick() {
    return 'cabiner' + Math.floor(Math.random() * 100).toString()
  }

  normalizeNickname(nickname) {
    return nickname.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '')
  }
}



// WEBPACK FOOTER //
// ./src/views/login/Login.jsx